document.addEventListener("DOMContentLoaded", () => {
	const loadMoreBtn = document.querySelector('.js-load_more_groups');
	const hiddenClass = 'm-hidden';

	if (!loadMoreBtn) {
		return;
	}


	loadMoreBtn.addEventListener('click', () => {
		const parent = loadMoreBtn.parentElement;

		if (parent) {
			const hiddenGroups = parent.querySelectorAll('.m-hidden');

			let timeout = 0;

			hiddenGroups.forEach(serviceTile => {
				setTimeout(() => {
					serviceTile.classList.remove(hiddenClass);
					serviceTile.style.opacity = 1;
				}, timeout);

				timeout += 200;
			});

			setTimeout(() => {
				loadMoreBtn.remove();
			}, hiddenGroups.length * 200);
		}
	})
});
